// extracted by mini-css-extract-plugin
export var childrenContainer = "_56-0";
export var virtualScrollArea = "_56-1";